module.exports = __webpack_public_path__ + "img/flag-checkered-solid.b36af9c4.svg";